import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PartnerAccountsPage } from '../screens/admin/partner-billing/PartnerAccountsPage';

const searchSchema = z.object({
  /** Part of a paying account's name, or the start of its Zoho id; every account when absent. */
  q: z.string().max(100).optional().catch(undefined),
  /** Where the page of accounts starts (the server's cursor); the first page when absent. */
  at: z.string().max(20).optional().catch(undefined),
});

/** The paying accounts (ADR-0036, section 7.1), found on the server a page at a time. */
export const Route = createFileRoute('/admin/partners/')({
  validateSearch: searchSchema,
  component: PartnerAccountsPage,
});
